var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4397 5.19019L18.8086 3.55894C18.0633 2.81367 16.8508 2.8137 16.1055 3.55894C15.4038 4.2607 4.68623 14.9791 3.96999 15.6954C3.8937 15.7716 3.84259 15.873 3.82437 15.9722L3.00882 20.3766C2.97722 20.5473 3.03164 20.7227 3.15444 20.8455C3.27738 20.9685 3.45281 21.0228 3.62335 20.9912L8.02733 20.1755C8.12911 20.1565 8.22916 20.1049 8.30419 20.0299L20.4397 7.89346C21.1867 7.14646 21.1868 5.93729 20.4397 5.19019ZM4.1855 19.8144L4.67885 17.1501L6.8496 19.321L4.1855 19.8144ZM7.93132 18.9112L5.08863 16.0683L15.4671 5.68902L18.3098 8.53193L7.93132 18.9112ZM19.6939 7.14769L19.0555 7.78616L16.2128 4.94325L16.8512 4.30478C17.1852 3.97073 17.7287 3.97069 18.0628 4.30478L19.6939 5.93603C20.0288 6.27089 20.0288 6.81279 19.6939 7.14769Z",
    fill: "#976821"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08887 16.0687L7.93156 18.9116L18.31 8.53236L15.4673 5.68945L5.08887 16.0687Z",
    fill: "#FEEFD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.dbb99710.svg";
export { ForwardRef as ReactComponent };